export default __webpack_public_path__ + "static/media/902.83f88865.png";